import { useSearchParams } from "react-router-dom";
import { ConfigAssistant } from "@/features/companies/config-assistant/ConfigAssistant";
import { useAppShell } from "@/shell/app-shell-context";
import { ApiState } from "@/shared/components/ApiState";
import { useRequireCompany } from "@/shared/hooks/useRequireCompany";
import { hasRoleAtLeast } from "@/shared/utils/roles";

/** `/empresas/:id/configuracoes/assistente` — o assistente de
 *  configuração, sob a empresa ativa (é a casca que publica o
 *  `X-Company-Id`). `?nova=1` é como o onboarding chega aqui logo depois
 *  de criar a empresa; só muda o texto de abertura. */
export function ConfigAssistantRoute() {
  const { token, profile } = useAppShell();
  const company = useRequireCompany();
  const [params] = useSearchParams();

  if (!company) return null;
  // O assistente escreve configuração; as rotas de company-config são de Especialista (2026-10-24).
  if (!hasRoleAtLeast(profile, "specialist")) {
    return <ApiState kind="error">O assistente de configuração é de Especialista ou acima.</ApiState>;
  }

  return (
    <ConfigAssistant
      token={token}
      companyId={company.id}
      companyName={company.name}
      isNew={params.get("nova") === "1"}
    />
  );
}
